import register from 'ShopUiBundle/modules/app/registry';
import 'ShopUiBundle/components/molecules/range-slider-scroll-x-container';
import './zoom-image.scss';

// tslint:disable-next-line
register('zoom-image', () => import(/* webpackMode: "lazy" */'./zoom-image'));
